import 'isomorphic-fetch';
import fetchCheck from '../redux/middleware/fetchCheck';

// Use "globalThis" instead of "window", "self", or "global" (javascript:S7764)
const window = globalThis.window;

// Ensure fetch always receives an absolute URL (node-fetch in tests rejects relatives).
const getBaseOrigin = () => {
  if (
    window?.location?.origin &&
    window?.location.origin !== 'null' &&
    window?.location.origin !== 'about:blank'
  ) {
    return window.location.origin;
  }

  return process.env.API_BASE_URL || 'http://localhost';
};

const toAbsoluteUrl = path => {
  if (!path) {
    return path;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  } // already absolute

  if (path.startsWith('//')) {
    return `https:${path}`;
  } // protocol-relative

  return new URL(path, getBaseOrigin()).toString();
};

const urlBase = '/cms/data/v1/sso/';
const options = {
  method: 'POST',
  credentials: 'include',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
};

const fetchSSO = (path, method, params) => {
  options.method = method;
  const opts = params ? { ...options, body: JSON.stringify(params) } : options;

  return fetch(toAbsoluteUrl(urlBase + path), opts)
    .then(res => fetchCheck(res, false))
    .then(res => res.json());
};

export const ssoLogin = (client, idp, redirect) =>
  fetchSSO('entrypoint', 'POST', { client, idp, redirect });

export const ssoFetchIdps = () => fetchSSO('idp', 'GET');
